import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { FinanceService } from '../shared/finance.service';
import { AngularFireDatabase } from 'angularfire2/database';
import 'rxjs/add/operator/toPromise';
import { formatDate } from '@telerik/kendo-intl';
import { CommonService } from 'app/common.service';
import { FORMERR } from 'dns';


@Component({
  selector: 'app-profit-loss',
  templateUrl: './profit-loss.component.html',
  styleUrls: ['./profit-loss.component.scss']
})
export class ProfitLossComponent implements OnInit {
  TransactionsList: any[];
  EmployeeSalaryList: any[];
  profitArray:any[];
  lossArray:any[];
  salesList:any[];
  totalLoss:any[];
  totalProfit:any[];
  netProfit:any[];
  amount:any;
  a:any
  finalRowAmount=0;
  totalSalesProfit=0;
  totalSalary=0;
  overallTotalProfit=0;
  overallTotalLoss=0;
  vat=0;

  constructor(private financeService:FinanceService) { }

  ngOnInit() {
    this.getAllTransactions();
    this.getAllEmployeeSalary();
    this.getSalesList();
    this.getVat();
  }

  getAllTransactions() {
    var self = this;
    var groups = {};
    this.profitArray = [];
    this.lossArray = [];
    this.amount = 0;
    this.financeService.getAllTransactionListByYear().then(res => { 
        self.TransactionsList = [];
        res.forEach(function (childSnap) {
        var groupName = String(childSnap.child("categoryName").val());
        if (!groups[groupName]) {
          groups[groupName] = [];
        }
        groups[groupName].push({
          "Date": String(childSnap.child("date").val()),
          "Description": String(childSnap.child("description").val()),
          "Amount": String(childSnap.child("amount").val()),
          "id": childSnap.key
        });
      });

      for (var groupName in groups) {
        groups[groupName].push({ "monthlyAmount": { "01": 0, "02": 0, "03": 0, "04": 0, "05": 0, "06": 0, "07": 0, "08": 0, "09": 0, "10": 0, "11": 0, "12": 0 } },{"finalRowAmount":0});
      }

      for (var groupName in groups) {
        var length = groups[groupName].length;
        for (var index in groups[groupName]) {
          if (index < String(groups[groupName].length - 2)) { // -1 ... -1
            var date = groups[groupName][index].Date.split("/");
            var month = String(date[1]);
            groups[groupName][length - 2].monthlyAmount[month] = groups[groupName][length - 2].monthlyAmount[month] + parseInt(groups[groupName][index].Amount); // -1
            groups[groupName][length - 1].finalRowAmount = groups[groupName][length-1].finalRowAmount + parseInt(groups[groupName][index].Amount); // not there
          }
        } 
      
        if(groups[groupName][0].Amount.indexOf('-')<=-1) {
          self.profitArray.push({ groupName: groupName, group: groups[groupName]});
        } else {
          self.lossArray.push({ groupName: groupName, group: groups[groupName] });
        }
    }
      //console.log(self.profitArray);
      //console.log(self.lossArray);
      
    });
}

getAllEmployeeSalary() {
  var self = this;
  this.financeService.getAllEmployeeSalary().then(res => {
    self.EmployeeSalaryList = [];
    for (var i = 0; i <= 11; i++) {
      self.EmployeeSalaryList[String(i)] = 0;
    }
    res.forEach(function (childSnap) {
      var key = childSnap.key - 1;
      childSnap.forEach(function (child) {
        self.EmployeeSalaryList[String(key)] = self.EmployeeSalaryList[String(key)] - parseInt(child.child("computedSalary").val());
      });
    });
    for (var i = 0; i <= 11; i++) {
      self.totalSalary = self.totalSalary + self.EmployeeSalaryList[i];
    }
    //console.log(self.EmployeeSalaryList);
    this.calculateLossAndProfit();
  });
}

getSalesList() {
  var self = this;
  this.financeService.getSalesList().then(res => {
    self.salesList = [];
    for (var i = 0; i <= 11; i++) {
      self.salesList[String(i)] = 0;
    }
    res.forEach(function (childSnap) {
        if(childSnap.child("total").val()) {
          var date = childSnap.child("createdAt").val();
          var splitDate = date.split('/');
          var month = splitDate[1];
          var key =month - 1;
          self.salesList[String(key)] = self.salesList[String(key)] + parseInt(childSnap.child("total").val());
        }
    });

    for (var i = 0; i <= 11; i++) {
      self.totalSalesProfit = self.totalSalesProfit + self.salesList[i];
    }
    //console.log(self.salesList);
  });
}

calculateLossAndProfit() {
  this.totalProfit = [];
  this.totalLoss = [];
  this.netProfit = [];
  
  for (var x = 0; x <= 11; x++) {
    this.totalProfit[String(x)] = 0.0;
    this.totalLoss[String(x)] = 0.0;
  }
  //Profit
  for(var i=0;i<this.profitArray.length;i++) {
    for(var j =0;j<this.profitArray[i].group.length;j++) {
      if(this.profitArray[i].group[j].Date) {
        var splitDate = this.profitArray[i].group[j].Date.split('/');
        var month = splitDate[1]-1;
        this.totalProfit[String(month)] = parseFloat(this.totalProfit[String(month)]) + parseFloat(this.profitArray[i].group[j].Amount);
      }
    }
  }

  //Loss
  for(var i=0;i<this.lossArray.length;i++) {
    for(var j =0;j<this.lossArray[i].group.length;j++) {
      if(this.lossArray[i].group[j].Date) {
        var splitDate = this.lossArray[i].group[j].Date.split('/');
        var month = splitDate[1]-1;
        this.totalLoss[String(month)] = this.totalLoss[String(month)] + parseFloat(this.lossArray[i].group[j].Amount);
      }
    }
  }

  //ADD SALES TO PROFIT AND PAYROLL TO LOSS
  for(var i=0;i<this.salesList.length;i++) {
    this.totalProfit[String(i)] = parseFloat(this.totalProfit[String(i)]) + parseFloat(this.salesList[i]);
    this.overallTotalProfit = this.overallTotalProfit + this.totalProfit[String(i)];
    this.totalLoss[String(i)] = parseFloat(this.totalLoss[String(i)]) + parseFloat(this.EmployeeSalaryList[i]);
    this.overallTotalLoss = this.overallTotalLoss + this.totalLoss[String(i)];
    this.netProfit[String(i)] = this.totalProfit[String(i)] + this.totalLoss[String(i)];
  }

  //console.log("totalProfit==> "+this.totalProfit);
  //console.log("totalLoss==> "+this.totalLoss);
}

getVat() {
  var x = this.financeService.getVat();
  this.vat = 0;
  x.snapshotChanges().subscribe(item=>{
    item.forEach(element =>{
      this.vat = (element.payload.child("vatAmount").val()/100);
      //console.log("vat"+this.vat);
    });
  });
}

}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/finance-management/profit-loss/profit-loss.component.ts